import { useSubmitVerificationDocument } from '@/hooks';
import { DocumentType } from '@/api/common.types';
import styles from '@/views/SignUp/components/Verification/Steps/Steps.module.css';
import { Controller } from 'react-hook-form';
import { Button, DragAndDrop } from '@/components/common';

interface IdentityVerificationProps {
  setStep: (step: number) => void;
}

export const IdentityVerification = ({ setStep }: IdentityVerificationProps) => {
  const { control, handleSubmit, isDirty, isValid, isSubmitting, reset, onSubmit } = useSubmitVerificationDocument(
    DocumentType.IDENTITY_VERIFICATION,
    () => setStep(2),
  );

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <h3 className={styles.title}>{'Please provide one form of\nidentity verification. *'}</h3>
      <p className={styles.description}>
        Either a passport or drivers license photo of all Ultimate Beneficial Owners or Directors that have over 20% of
        shares in the business.
      </p>

      <Controller
        name="document"
        control={control}
        render={({ field: { ref, value, ...rest } }) => (
          <DragAndDrop {...rest} value={value} className={styles.input} multiple />
        )}
      />
      <Button fluid variants="secondaryGray" className={styles.clearFilesBtn} onPress={() => reset()}>
        Clear files
      </Button>
      <Button
        fluid
        icon="chevronRight"
        iconPosition="right"
        type="submit"
        loading={isSubmitting}
        isDisabled={!isDirty || !isValid}
      >
        Next Step
      </Button>
    </form>
  );
};
